// Registers all effect stubs 1–8. Each is an independent bus subscriber with its own kill switch;
// order here is just registration order (it does not affect firing). Add effect 9+ by dropping a
// file in this folder, a config block in feel.json, and one line here.
import { registerHitstop } from "./01-hitstop";
import { registerSound } from "./02-sound";
import { registerTween } from "./03-tween";
import { registerCountup } from "./04-countup";
import { registerScreenshake } from "./05-screenshake";
import { registerTilepop } from "./06-tilepop";
import { registerParticles } from "./07-particles";
import { registerPitchramp } from "./08-pitchramp";
import { registerPersonality } from "./09-personality";

export function registerAllEffects(): void {
  registerHitstop();
  registerSound();
  registerTween();
  registerCountup();
  registerScreenshake();
  registerTilepop();
  registerParticles();
  registerPitchramp();
  registerPersonality();
}
